define( function() {
	return ( /\?/ );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/ajax/var/rquery.js
 ** module id = 490
 ** module chunks = 2
 **/